import Component from '@glimmer/component';

import { service } from '@ember/service';

import CAtom from 'rise-ui/components/c-atom.gjs';
import CButton from 'rise-ui/components/c-button.gjs';
import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import Result from 'rise-ui/components/time-series/search/result.gjs';
import not from 'rise-ui/helpers/not.js';
import set from 'rise-ui/helpers/set.js';
import string from 'rise-ui/helpers/string.js';
import timeSeriesSelect from 'rise-ui/helpers/time-series-select.js';
import sticky from 'rise-ui/modifiers/sticky.js';
import or from 'rise-ui/helpers/or';

export default class TimeSeriesSearchSelectedComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;
  @service ssr;

  <template>
    {{#if this.selectedLocations.locations.isResolved}}
      <Sticky @name="selected--large" @type="large">
        <h4 class="c-section-title c-search__selected-label">
          {{string "time-series-selected-locations"}}
        </h4>
        <div class="c-selected-results">
          {{#each this.selectedLocations.locations.value as | location |}}
            <Result
              @location={{location}}
              @added={{true}}
              @context="remove"
              @allowRemove={{true}}
            />
          {{else}}
            <div class="c-selected-results__empty">
              {{string "time-series-select-locations-prompt"}}
            </div>
          {{/each}}
        </div>
      </Sticky>
    {{/if}}

    {{#if this.selectedLocations.count}}
      <Sticky @name="selected--small" @type="small">
        <ExpandingBlock
          @button={{true}}
          @onToggle={{set this "isSelectedLocationShown"}}
        >
          <:head>
            {{if this.isSelectedLocationShown "Hide" "Show"}}
            {{string "time-series-selected-locations"}}
            ({{this.selectedLocations.count}})
          </:head>
          <:body>
            <div class="c-selected-results">
              {{#each this.selectedLocations.locations.value as | location |}}
                <Result
                  @location={{location}}
                  @added={{true}}
                  @context="remove"
                  @allowRemove={{true}}
                />
              {{/each}}
            </div>
          </:body>
        </ExpandingBlock>
      </Sticky>
    {{/if}}

    <div class="c-search__selected"
      {{sticky activate="selected--small selected--large"}}
    >
      <h4 class="c-section-title c-search__selected-label">
        {{string "time-series-selected-locations"}}
      </h4>
      <div class="c-search__selected-reset">
        <CButton
          @linkTo={{timeSeriesSelect clearLocations=true}}
          @disabled={{not this.selectedLocations.count}}
        >
          Clear Selections
        </CButton>
      </div>
      {{#if this.selectedLocations.hasExcessLocations}}
        <div class="c-error c-search__selected-error">
          Too many locations selected. Maximum of
          {{this.selectedLocations.maxSelectedLocations}}
          allowed. Use the remove buttons below
          <CAtom>(<span class="c-add-button c-add-button--example c-add-button--remove-context c-add-button--added c-add-button--remove-context--added"></span>)</CAtom>
          or edit the URL to reduce the number of selected locations.
        </div>
      {{/if}}
      <div class="c-search__selected-locations c-selected-results">
        {{#if (or this.selectedLocations.locations.isPending this.ssr.isSsr)}}
          <div class="c-selected-results__init qa-selected-locations-loading">
            Loading {{string "time-series-selected-locations"}}...
          </div>
        {{else if this.selectedLocations.locations.isRejected}}
          <div class="c-no-result c-search__results-empty qa-selected-locations-error">
            Error loading locations
          </div>
        {{else}}
          {{#each this.selectedLocations.locations.value as | location |}}
            <Result
              @location={{location}}
              @added={{true}}
              @context="remove"
              @allowRemove={{true}}
            />
          {{else}}
            <div class="c-selected-results__empty qa-selected-locations-empty">
              {{string "time-series-select-locations-prompt"}}
            </div>
          {{/each}}
        {{/if}}
      </div>
    </div>
  </template>
}
